import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  ActivatedRoute,
  CanActivateChild
} from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class NotLoggedInCongresService implements CanActivate {

  constructor(private storagedata: StorageService, private router:Router, private activatedRoute:ActivatedRoute) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if(this.storagedata.connectedInCV()){
      console.log('logged in');
      this.router.navigateByUrl('/congres-virtuel/');

    }
    return !this.storagedata.connectedInCV();
  }
}
